import styled from 'styled-components';

export const DescriptionStyles = styled.div`
  //padding: 2em;
  background-color: #02044a;
  flex-basis: 60%;
`;
